import { useParams } from "react-router-dom";
import { useSite } from "../../lib/useSite";
import { Eyebrow } from "../../components/bits";

const MAP = {
  privacy: ["Privacy Policy", "privacy"],
  cookie: ["Cookie Policy", "cookie"],
  terms: ["Terms of Service", "terms"],
  cancellation: ["Cancellation Policy", "cancellation"],
  complaints: ["Complaints Policy", "complaints"],
  accessibility: ["Accessibility", "accessibility"],
};

export default function Legal() {
  const { slug } = useParams();
  const site = useSite();
  const policies = site?.policies || {};
  const [title, key] = MAP[slug] || ["Policy", slug];
  const body = policies[key] || "This policy will be published here. Contact us for details in the meantime.";
  return (
    <div>
      <section className="bg-[#0a0a0a] relative">
        <div className="absolute inset-0 noise-overlay" />
        <div className="relative max-w-4xl mx-auto px-5 sm:px-8 pt-20 pb-12">
          <Eyebrow dark>Legal</Eyebrow>
          <h1 className="font-display text-[#fdfbf7] text-4xl sm:text-5xl tracking-tight">{title}</h1>
        </div>
      </section>
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14">
        <p className="text-[#333] leading-relaxed whitespace-pre-line">{body}</p>
        <p className="text-xs text-[#8a8a8a] mt-10">
          This content is editable by management and is provided for general information. It is not presented as solicitor-reviewed legal advice.
          We follow UK GDPR principles including data minimisation, access control and retention limits.
        </p>
      </div>
    </div>
  );
}
